import { useEffect, useState } from "react";
import Modal from "react-modal";
import { Button } from "../common/Forms";
import Icon from "../common/Icon";

const SurveyAddModal = ({ open, data, onAdd, onClose }) => {
  const [target, setTarget] = useState("parent");
  const [lecture, setLecture] = useState(null);
  const handleClick = (e) => {
    setTarget(e.target.id);
  };
  const handleSelect = (e) => {
    setLecture(e.target.value);
  };
  const handleAdd = () => {
    onAdd({ target, lecture });
  };
  useEffect(() => {
    if (data && "selectedLecture" in data && data.selectedLecture) {
      setLecture(data.selectedLecture);
    }
  }, [data]);
  return (
    <>
      {open && (
        <Modal
          ariaHideApp={false}
          className="h-full text-center flex"
          isOpen={open}
          onRequestClose={onClose}
        >
          <div className="card bg-white w-full md:w-6/12 md:shadow-xl m-auto p-4">
            <div className="inline-flex items-center gap-4">
              <span className="font-bold text-sm text-end w-12">대상</span>
              <div className="btn-group w-full">
                <button
                  id="parent"
                  className={`btn w-1/2 btn-ghost border border-zinc-200 ${
                    target === "parent" && "btn-active"
                  }`}
                  onClick={handleClick}
                >
                  학부모
                </button>
                <button
                  id="student"
                  className={`btn w-1/2 btn-ghost border border-zinc-200 ${
                    target === "student" && "btn-active"
                  }`}
                  onClick={handleClick}
                >
                  학생
                </button>
              </div>
            </div>
            <div className="inline-flex gap-4 items-center mt-2">
              <h3 className="text-sm font-bold w-12 text-end">강의</h3>
              <select
                id="classes"
                name="classes"
                autoComplete="classes-name"
                className="h-12 mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-cyan-500 focus:outline-none focus:ring-cyan-500 sm:text-sm"
                onChange={handleSelect}
                defaultValue={data.selectedLecture}
              >
                {"lectureList" in data &&
                  data.lectureList.map(({ _id: id, title: v }) => (
                    <option key={`option_${v}`} value={id}>
                      {v}
                    </option>
                  ))}
              </select>
            </div>
            <div className="card-actions mt-4 w-full">
              <Button
                type="primary"
                className="w-full"
                disabled={!lecture}
                onClick={handleAdd}
              >
                <Icon name="plus" size="sm" className="inline-block" />
                추가
              </Button>
              <Button
                className="w-full bg-zinc-300 border-0 text-black hover:bg-zinc-400"
                onClick={onClose}
              >
                <Icon name="x" size="sm" className="inline-block" />
                닫기
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SurveyAddModal;
